import { useCallback, useState } from "react";

import { useGlobalEvent } from "../../../../common/hooks/useGlobalEvent";
import { ACCORDION_EVENT } from "./constants";

export const useAccordionSelectorControl = (
	accordion_id: string,
	autoCollapse: boolean,
	isExpanded: boolean
) => {
	const [expanded, setExpanded] = useState<boolean>(isExpanded);

	const listenExpand = useCallback(
		(id: string) => {
			if (id === accordion_id) {
				setExpanded(true);

				return;
			}
			if (!autoCollapse) return;
			setExpanded(false);
		},
		[accordion_id, autoCollapse]
	);

	const listenCollapse = useCallback(
		(id: string) => {
			if (id !== accordion_id) return;
			setExpanded(false);
		},
		[accordion_id]
	);

	useGlobalEvent(ACCORDION_EVENT.EXPAND, listenExpand);
	useGlobalEvent(ACCORDION_EVENT.COLLAPSE, listenCollapse);

	return {
		expanded,
	};
};
